import { useNavigate } from 'react-router-dom';
import { useStore } from '@/store/useStore';
import { Wallet, LogOut } from 'lucide-react';

export const Header = () => {
  const navigate = useNavigate();
  const user = useStore((state) => state.user);
  const isWebMode = useStore((state) => state.isWebMode);
  const logout = useStore((state) => state.logout);

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="sticky top-0 z-10 bg-telegram-bg border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {isWebMode && (
            <span className="text-sm font-bold text-telegram-text">🎰 Ruffle</span>
          )}
          <div className="flex items-center gap-3 ml-auto">
            {user && (
              <div className="flex items-center gap-2 bg-telegram-button text-telegram-buttonText px-4 py-2 rounded-lg">
                <Wallet size={18} />
                <div className="text-right">
                  <div className="text-sm font-bold">
                    {user.balance.toFixed(2)} ₽
                  </div>
                  <div className="text-xs opacity-80">
                    Баланс
                  </div>
                </div>
              </div>
            )}
            {isWebMode && user && (
              <button
                onClick={handleLogout}
                title="Выйти"
                className="flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors px-2 py-2 rounded-lg"
              >
                <LogOut size={18} />
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
